<nz-card>
  <div nz-col class="activation-channel-content" nzSpan="24">
    <nz-spin nzTip="Loading..." [nzSize]="'large'" [nzSpinning]="isLoading">
      <div class="content">
        <div class="table-content">
          <nz-table
            nzSize="small"
            [nzData]="rowsToDisplay"
            nzTableLayout="fixed"
            nzShowPagination
            nzShowSizeChanger
            [nzLoading]="isLoading"
            [nzFrontPagination]="true"
            [nzTotal]="totalCount!"
            [nzOuterBordered]="true"
            [nzPageSizeOptions]="supportedPageSizes"
            [nzNoResult]="noResultTemplate"
            [nzHideOnSinglePage]="false"
            [nzVirtualItemSize]="11"
            [nzScroll]="{ x: '75rem', y: '30rem' }"
            #borderedTable
            nzBordered
          >
            <thead>
              <tr>
                <th
                  *ngFor="let cell of headers; index as i"
                  nz-resizable
                  [nzSortOrder]="cell.sortOrder"
                  [nzSortFn]="cell.sortFn"
                  [nzSortDirections]="cell.sortDirections"
                  [nzFilterMultiple]="cell.filterMultiple"
                  [nzFilters]="cell.listOfFilter"
                  [nzFilterFn]="cell.filterFn"
                  [nzWidth]="cell.width ?? '8rem'"
                  [nzRight]="cell.right"
                  [nzLeft]="cell.left"
                  class="nfl-form-label"
                  [nzCustomFilter]="i === 0"
                  appResizableColumn
                  [isDynamicTable]="true"
                >
                  {{ cell.name }}
                  <nz-filter-trigger
                    *ngIf="i === 0"
                    [(nzVisible)]="visible"
                    [nzActive]="searchValue!.length > 0"
                    [nzDropdownMenu]="filterMenu"
                  >
                    <span nz-icon nzType="search"></span>
                  </nz-filter-trigger>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of borderedTable.data">
                <td nzEllipsis [nz-tooltip]="data.exportId">{{ data.exportId }}</td>
                <td nzEllipsis [nz-tooltip]="data.queryId">{{ data.queryId }}</td>
                <td nzEllipsis [nz-tooltip]="data.queryName">{{ data.queryName }}</td>
                <td>{{ data.targetChannel | titlecase }}</td>
                <td>{{ getAudienceFrom(data.audienceFrom ?? '') }}</td>
                <td>{{ data.exportedBy }}</td>
                <td>{{ data.exportedAt | dateTime }}</td>
                <td>{{ data.expireAt | dateTime }}</td>
                <td nzAlign="center">
                  <nz-tag [nzColor]="getApprovalStatusColor(data.approvalStatus)">
                    {{ data.approvalStatus | titlecase }}
                  </nz-tag>
                </td>
                <td nzAlign="center">
                  <nz-tag [nzColor]="getExportStatusColor(data.exportStatus)">
                    {{ data.exportStatus | titlecase }}
                  </nz-tag>
                </td>
                <td nzAlign="center" nzRight>
                  <button
                    nz-button
                    nz-dropdown
                    [nzDropdownMenu]="actionMenu"
                    [disabled]="!allowActions(data)"
                    nz-tooltip
                    [nzTooltipTitle]="!appService.isEngagementActive ? 'Engagement is not active' : ''"
                  >
                    <span nz-icon nzType="more"></span>
                  </button>
                  <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                    <ul nz-menu *ngIf="allowActions(data)">
                      <li nz-menu-item (click)="approveExport(data, confirmApproveModal)">Approve</li>
                      <li nz-menu-item (click)="rejectExport(data, rejectReasonModal)">Reject</li>
                    </ul>
                  </nz-dropdown-menu>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </nz-spin>
  </div>

  <ng-template #noResultTemplate let-name>
    <div>
      <span nz-icon nzType="file-sync" nzTheme="outline"></span>
      <p>No records available</p>
    </div>
  </ng-template>

  <nz-dropdown-menu #filterMenu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input type="text" nz-input placeholder="Search Export ID" [(ngModel)]="searchValue" />
        <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button>
        <button nz-button nzSize="small" (click)="reset()">Reset</button>
      </div>
    </div>
  </nz-dropdown-menu>
</nz-card>

<ng-template #rejectReasonModal let-modal>
  <form nz-form nzLayout="vertical">
    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="rejectReason" class="nfl-form-label">Reject Reason</nz-form-label>
      <nz-form-control [nzErrorTip]="rejectReasonErrorTemplate">
        <textarea
          nz-input
          [formControl]="rejectReason"
          nzSize="large"
          id="rejectReason"
          placeholder="Reject Reason"
          appTrimFormInput
          [nzAutosize]="{ minRows: 2, maxRows: 6 }"
          maxlength="500"
        ></textarea>
      </nz-form-control>
      <ng-template #rejectReasonErrorTemplate let-control>
        <div *ngIf="control?.errors?.['required']">Please enter the Reject Reason</div>
        <div *ngIf="control?.errors?.['minlength']">
          Reject Reason must be at least
          {{ control?.errors?.['minlength'].requiredLength }} characters long.
        </div>
        <div *ngIf="control?.errors?.['pattern']">Reject Reason should have at least one alphabet.</div>
      </ng-template>
    </nz-form-item>
    <nz-form-item class="button-section">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button (click)="rejectModalRef.close()">Cancel</button>
        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          [disabled]="!rejectReason.valid"
          (click)="rejectModalRef.triggerOk()"
        >
          Reject
        </button>
      </nz-space>
    </nz-form-item>
  </form>
</ng-template>

<ng-template #confirmApproveModal let-modal>
  <form nz-form nzLayout="vertical">
    <nz-form-item>
      <label nz-checkbox class="nfl-form-label" [formControl]="dataGovernanceApproval">
        Do you have approval from Data Governance Team ?
      </label>
    </nz-form-item>
    <nz-form-item class="button-section">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button (click)="approveModalRef.triggerCancel()">Cancel</button>
        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          [disabled]="dataGovernanceApproval.invalid || dataGovernanceApproval.value === false"
          (click)="approveModalRef.triggerOk()"
        >
          Approve
        </button>
      </nz-space>
    </nz-form-item>
  </form>
</ng-template>
